export default {"src":"/_next/static/media/iconMenuGray.071ce00f.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};